import type { ReactElement } from 'react';

import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from '@/shared/ui/dropdown-menu';
import { filterItemSelectedClass } from './styles';

type FilterColumnPickerProps = {
  fields: { id: string; label: string; locked?: boolean }[];
  selectedIds: string[];
  onSelectionChange: (ids: string[]) => void;
  widthClassName?: string;
  trigger: ReactElement;
};

/** Le colonne visibili di una tabella; `trigger` è il pulsante che apre il menu. */
export default function FilterColumnPicker({
  fields,
  selectedIds,
  onSelectionChange,
  widthClassName = 'w-56',
  trigger,
}: FilterColumnPickerProps) {
  const toggle = (id: string, checked: boolean) => {
    const lockedIds = fields.filter((field) => field.locked).map((field) => field.id);
    const nextIds = checked
      ? [...selectedIds, id]
      : selectedIds.filter((selected) => selected !== id);

    onSelectionChange([...new Set([...lockedIds, ...nextIds])]);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>{trigger}</DropdownMenuTrigger>

      <DropdownMenuContent sideOffset={6} align="end" className={widthClassName}>
        <DropdownMenuLabel>Colonne visibili</DropdownMenuLabel>
        <div className="flex max-h-60 flex-col gap-1 overflow-auto">
          {fields.map((field) => (
            <DropdownMenuCheckboxItem
              key={field.id}
              checked={selectedIds.includes(field.id)}
              disabled={field.locked}
              onCheckedChange={(checked) => toggle(field.id, checked === true)}
              className={filterItemSelectedClass}
            >
              <span className="min-w-0 flex-1 font-medium">{field.label}</span>
            </DropdownMenuCheckboxItem>
          ))}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
